const _state = {
  validationMessages: [],
  currentAcademicYear: sessionStorage.getItem('current-academic-year')
    ? JSON.parse(sessionStorage.getItem('current-academic-year'))
    : null,
};

export const initialState = () => _state;

export const state = initialState();
